import axios from "../axiosInstance";

const brandingKitAPI = {
  addFolder: (payload) => axios.post("admin/branding-kit/add-folder", payload),
  getFolder: () => axios.get("admin/branding-kit/get-folder-list"),

  getDetails: (payload) => axios.post("admin/game/details", payload),

  update: (payload) => axios.post("admin/game/update", payload),
  delete: (payload) => axios.post("admin/game/delete", payload),

  uploadFile: (payload) => axios.post("admin/branding-kit/uploadFile", payload),
  getFiles: (payload) => axios.post("admin/branding-kit/getFiles", payload),
};

export default brandingKitAPI;
